import {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from 'next';
import UseCase from 'pages/use-cases/[useCase]';
import { getAllMenuPage } from 'repos/menu';
import { getAllUseCases } from 'repos/solutionPage';

export default function Industry({
  menuParams,
  industry,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return <UseCase menuParams={menuParams} useCase={industry} />;
}

export async function getStaticPaths({ locales }: GetStaticPathsContext) {
  const industries = (await getAllUseCases({})).filter(
    (u) => u.fields.isIndustry
  );
  const paths = (locales || []).flatMap((locale) => {
    return industries.map((industry) => ({
      locale,
      params: {
        industry: industry.fields.slug,
      },
    }));
  });

  return {
    paths,
    fallback: false,
  };
}

export const getStaticProps = async ({
  locale,
  params,
}: GetStaticPropsContext) => {
  const slug = params?.industry;
  if (!slug) {
    throw new Error('No industry provided');
  }

  const industries = (await getAllUseCases({ locale })).filter(
    (u) => u.fields.isIndustry
  );
  const industry = industries.find((i) => i.fields.slug === slug);

  if (!industry) {
    throw new Error('No industry found');
  }
  const menuParams = await getAllMenuPage({ locale });

  return {
    props: {
      industry,
      menuParams,
    },
  };
};
